import {
  section,
  container,
  image,
  content,
  titleText,
  descriptionText,
  button,
  mobileImage,
  mobileContent,
  buttonsContainer,
  auxTitleText,
} from './SobreDoutora.styles';
import ProfileFade from '../../assets/doutorafade.jpg';
import ProfileMobile from '../../assets/doutora.jpg';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { useEffect, useState, useCallback } from 'react';
import { handleOpenLink } from '../../utils/common';

export default function SobreDoutora() {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  const getMobile = useCallback(
    () => (
      <div className={container}>
        <p className={auxTitleText}>Dra. Bruna Fais</p>
        <p className={titleText}>CRO-SP 157877</p>
        <img src={ProfileMobile} alt='SobreDoutora' className={mobileImage} />
        <div className={mobileContent}>
          <p className={descriptionText}>
            Cirurgiã-dentista formada pela Pontifícia Universidade Católica de
            Campinas (PUCCAMP), com especialização em Harmonização Orofacial
            pela Faculdade CTA Campinas.
          </p>
          <br />
          <p className={descriptionText}>
            Possui extensão em Preenchimento Full Face pela Florida
            International University (FIU) – Miami, com foco em técnicas
            avançadas que unem ciência e arte para resultados naturais e
            personalizados.
          </p>
          <br />
          <p className={descriptionText}>
            Sua atuação é marcada pela busca constante de excelência,
            priorizando a harmonização estética de forma segura, sutil e
            minimalista.
          </p>
          <div className={buttonsContainer}>
            <button
              onClick={() =>
                handleOpenLink(
                  'https://wa.me/+5519996268961?text=Ol%C3%A1,%20venho%20atrav%C3%A9s%20do%20site%20e%20gostaria%20de%20agendar%20uma%20Avalia%C3%A7%C3%A3o%20em%20Harmoniza%C3%A7%C3%A3o%20Orofacial%20com%20a%C2%A0Dra%C2%A0Bruna%C2%A0Fais.',
                  'agendar_consulta_click',
                  'Agendar consulta',
                  window.location.pathname
                )
              }
              className={button}
            >
              <FaWhatsapp />
              Agendar consulta
            </button>
            <button
              onClick={() =>
                handleOpenLink(
                  'https://www.instagram.com/drabfclinic/',
                  'instagram_click',
                  'Acessar Instagram',
                  window.location.pathname
                )
              }
              className={button}
            >
              <FaInstagram />
              drabfclinic
            </button>
          </div>
        </div>
      </div>
    ),
    [isMobile]
  );

  const getDesktop = useCallback(
    () => (
      <div className={container}>
        <img src={ProfileFade} alt='SobreDoutora' className={image} />
        <div className={content}>
          <p className={titleText}>Dra. Bruna Fais – CRO-SP 157877</p>

          <p className={descriptionText}>
            Cirurgiã-dentista formada pela Pontifícia Universidade Católica de
            Campinas (PUCCAMP), com especialização em Harmonização Orofacial
            pela Faculdade CTA Campinas.
          </p>
          <br />
          <p className={descriptionText}>
            Possui extensão em Preenchimento Full Face pela Florida
            International University (FIU) – Miami, com foco em técnicas
            avançadas que unem ciência e arte para resultados naturais e
            personalizados.
          </p>
          <br />
          <p className={descriptionText}>
            Sua atuação é marcada pela busca constante de excelência,
            priorizando a harmonização estética de forma segura, sutil e
            minimalista.
          </p>
          <div className={buttonsContainer}>
            <button
              onClick={() =>
                handleOpenLink(
                  'https://wa.me/+5519996268961?text=Ol%C3%A1,%20venho%20atrav%C3%A9s%20do%20site%20e%20gostaria%20de%20agendar%20uma%20Avalia%C3%A7%C3%A3o%20em%20Harmoniza%C3%A7%C3%A3o%20Orofacial%20com%20a%C2%A0Dra%C2%A0Bruna%C2%A0Fais.',
                  'agendar_consulta_click',
                  'Agendar consulta',
                  window.location.pathname
                )
              }
              className={button}
            >
              <FaWhatsapp />
              Agendar consulta
            </button>
            <button
              onClick={() =>
                handleOpenLink(
                  'https://www.instagram.com/drabfclinic/',
                  'instagram_click',
                  'Acessar Instagram',
                  window.location.pathname
                )
              }
              className={button}
            >
              <FaInstagram />
              drabfclinic
            </button>
          </div>
        </div>
      </div>
    ),
    [isMobile]
  );

  return (
    <section className={section} id='sobre'>
      {isMobile ? getMobile() : getDesktop()}
    </section>
  );
}
